import React, { useEffect, useState } from "react";
import Axios from "../../_services/caller.service";
import styles from "./ManageMics.module.scss";
import { MICRO_TYPES, MICRO_COLORS, MICRO_TEXT_COLORS } from "./configMics";

import InputForms from "../../components/UiComponents/forms/InputForms";
import { FiRefreshCcw } from "react-icons/fi";
import {
  BsFillExclamationTriangleFill,
} from "react-icons/bs";
import { IoMdAddCircle } from "react-icons/io";
import Modal from "../../components/UiComponents/modals/Modal";

import InviteForms from "../Team/InvitUser/InviteForms";
import useModal from "../../hooks/useModal";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import UploadDataMics from "./UploadDataMics";
import TutorialUploadDataMics from "./TutorialUploadDataMics";
import { PermissionGate } from "../superAdmin/managePermissions/PermissionGate";

const ManageMics = () => {
  const { t } = useTranslation();
  //USERS
  const [micros, setMicros] = useState([]);
  const [updateMicros, setUpdateMicros] = useState({});
  const [maj, setMaj] = useState(false);
  // RECHERCHE ET FILTRE
  const [searchTerm, setSearchTerm] = useState(""); // Pour la recherche micro
  const [filteredMicros, setFilteredMicros] = useState(micros);
  const [selectedMicros, setSelectedMicros] = useState("all");

  //PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage, setUsersPerPage] = useState(10);

  //INSERT A NEW MICS
  const [serial, setSerial] = useState("");
  const [micType, setMicType] = useState("Umik1");
  const [correctionL, setCorrectionL] = useState("");
  const [correctionR, setCorrectionR] = useState("");
  //MODAL
  const { isShowing, toggle } = useModal();
  const [activeForm, setActiveForm] = useState(null); // 'addNewMics', 'warningChangeValueMics', or null
  const [currentUpdate, setCurrentUpdate] = useState(null);
  const [showImport, setShowImport] = useState(false);
  //active l'un ou l'aautre du contenu modal
  const customToggle = () => {
    setActiveForm(null);
    toggle();
  };

  //GET ALL MICROS
  useEffect(() => {
    Axios.get("/getMicsSerials")
      .then((response) => {
        setMicros(response.data.results);
        setFilteredMicros(response.data.results);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [maj]);

  //UPDATE MICROS
  const handleUpdate = (serial, mictype) => {
    // Récupérer le micro d'origine en fonction du serial
    const originalMicro = filteredMicros.find(
      (mic) => mic.serial === serial && mic.mictype === mictype
    );

    // Récupérer les mises à jour pour ce serial spécifique (cela pourrait être un objet vide si aucune mise à jour n'a été apportée)
    const updatesForThisMicro = updateMicros[serial] || {};

    setCurrentUpdate({
      ...originalMicro,
      ...updatesForThisMicro,
    });

    // Montrer la modal de warning
    setActiveForm("warningChangeValueMics");
    toggle();
  };

  const confirmUpdate = () => {
    if (currentUpdate) {
      const microToSend = currentUpdate;
      console.log(microToSend);
      Axios.put("/updateMicSerial", microToSend)
        .then((response) => {
          toast.success(t("mics.mic_updated"));
          // Mettre à jour l'état global de micros

          setMicros((prevMicros) => {
            const updatedMicros = prevMicros.map((mic) =>
              mic.serial === microToSend.serial &&
              mic.mictype === microToSend.mictype
                ? microToSend
                : mic
            );

            // Réappliquer les filtres pour conserver les filtres après la mise à jour
            const updatedFilteredMicros = filterMicros(
              updatedMicros,
              searchTerm,
              selectedMicros
            );
            setFilteredMicros(updatedFilteredMicros);

            return updatedMicros;
          });

          // Effacer updateMicros pour le serial spécifique
          setUpdateMicros((prevState) => {
            const newState = { ...prevState };
            delete newState[serial];
            return newState;
          });
          setCurrentUpdate(null);
          customToggle();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  //REMETTRE LES FILTRES APRES UNE MAJ DES DONNEES MICRO
  const filterMicros = (microsArray, search, selected) => {
    let result = microsArray;

    // Appliquer le filtre de recherche
    if (search) {
      result = result.filter(
        (mic) =>
          mic.mictype.includes(search) ||
          mic.serial.toLowerCase().includes(search.toLowerCase())
      );
    }

    // Appliquer le filtre de sélection
    if (selected !== "all") {
      result = result.filter((mic) => mic.mictype === selected);
    }

    return result;
  };
  //Permet de conserver les filtres si il y a un maj des données micros
  useEffect(() => {
    // Si currentUpdate est null, cela signifie que la mise à jour vient d'être confirmée
    if (!currentUpdate && micros.length > 0) {
      const updatedFilteredMicros = filterMicros(
        micros,
        searchTerm,
        selectedMicros
      );
      setFilteredMicros(updatedFilteredMicros);
    }
  }, [currentUpdate, micros, searchTerm, selectedMicros]);

  //INSERT NEW MICS
  const addNewMics = () => {
    if (serial.length !== 7) {
      toast.error(t("mics.serial_length_validation"));
      // Vous pouvez également afficher un message d'erreur à l'utilisateur à ce stade
      return;
    }

    Axios.post("/addNewMics", {
      serial: serial,
      micType: micType,
      correctionL: correctionL,
      correctionR: correctionR,
    })
      .then((response) => {
        if (response.data.error) {
          console.error(response.data.message);
          toast.error(response.data.message);
        } else {
          setCorrectionL("");
          setCorrectionR("");
          setSerial("");
          setMicType("Umik1");
          setMaj(!maj);
          if (response.data.message === "Microphone ajouté avec succès.") {
            toast.success(t("mics.new_mic_success"));
          }
          if (response.data.message === "Microphone mis à jour avec succès.") {
            toast.success(t("mics.mic_updated_success"));
          }
          customToggle();
        }

        console.log(response.data.message);
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.message);
        } else {
          console.error(error.request);
          toast.error(t("common.no_server_response"));
        }
      });
  };

  //RECHERCHE
  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    console.log(`Term for search: ${term}`);

    const searchedMicros = micros.filter((mic) => {
      const serialString = mic.serial.toString().toLowerCase();
      const match = serialString.includes(term);
      console.log(`Checking mic serial: ${serialString}, Match: ${match}`);
      return match;
    });

    console.log(`Filtered micros: ${searchedMicros.length}`);
    setFilteredMicros(searchedMicros);
  };

  //FILTRE DE RECHERCHE
  const handleFilterChange = () => {
    let newFilteredMicros;

    if (selectedMicros === "all") {
      newFilteredMicros = [...micros]; // return all users if no filters are applied
    } else {
      newFilteredMicros = micros.filter((mic) => {
        return selectedMicros !== "all" ? mic.mictype === selectedMicros : true;
      });
    }

    setFilteredMicros(newFilteredMicros);
  };

  useEffect(() => {
    handleFilterChange();
  }, [selectedMicros, micros]);

  // FONCTION POUR CHANGER LES VALUES DANS LE STATE UPDATE MICROS
  const handleInputChange = (serial, mictype, field, value) => {
    // Construire une clé unique basée sur le serial et le mictype
    const uniqueKey = `${serial}-${mictype}`;

    // Mettre à jour l'état de updateMicros
    setUpdateMicros((prevState) => ({
      ...prevState,
      [uniqueKey]: {
        ...prevState[uniqueKey],
        [field]: value,
      },
    }));

    // Mettre à jour l'état de micros pour refléter les changements dans l'UI
    setFilteredMicros((prevMicros) => {
      return prevMicros.map((mic) => {
        if (mic.serial === serial && mic.mictype === mictype) {
          return { ...mic, [field]: value };
        }
        return mic;
      });
    });
  };

  //REFRESH FILTER

  const refreshfilter = () => {
    setFilteredMicros(micros);
    setSelectedMicros("all");
    setUsersPerPage(10);
    setSearchTerm("");
  };

  //PAGINATION

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const currentMicros = filteredMicros.slice(indexOfFirstUser, indexOfLastUser);

  const pageNumbers = [];
  // Juste après avoir calculé currentUsers
  const totalPages = Math.ceil(filteredMicros.length / usersPerPage);
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <div className={styles.page}>
        <div className={styles.header}>
          <h2>{t("mics.manage_title")}</h2>
        </div>

        <div className={styles.moduleCard}>
          <div className={styles.containerSearchAndFilter}>
            <input
              type="text"
              className={styles.searchInput}
              onChange={handleSearch}
              value={searchTerm}
              placeholder={t("mics.search_serial")}
            />
            <select
              value={usersPerPage}
              onChange={(e) => {
                setUsersPerPage(e.target.value);
                setCurrentPage(1); // réinitialiser la page actuelle
              }}
              className={styles.selectUserPerPage}
            >
              {[5, 10, 20, 30, 50].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>

            {/* Sélecteur de groupe */}
            <select
              value={selectedMicros}
              onChange={(e) => {
                setSelectedMicros(e.target.value);
                handleFilterChange();
              }}
              className={styles.selectMicro}
            >
              <option value="all">{t("mics.all_mics")}</option>
              {MICRO_TYPES.map((group) => (
                <option key={group} value={group}>
                  {group}
                </option>
              ))}
            </select>

            <button
              type="button"
              className={styles.iconButton}
              onClick={refreshfilter}
            >
              <FiRefreshCcw /> Rafraîchir
            </button>

            <PermissionGate actionKey="ManageMics.addNewMics">
              <button
                type="button"
                className={styles.primaryButton}
                onClick={() => {
                  setActiveForm("addNewMics");
                  toggle();
                }}
              >
                <IoMdAddCircle /> {t("mics.add_mic")}
              </button>
            </PermissionGate>
          </div>

          {/* ═══ TABLE DES MICROS ═══ */}
          <div className={styles.tableWrapper}>
            <table className={styles.microTable}>
              <thead>
                <tr>
                  <th>Serial</th>
                  <th>Type</th>
                  <th>Correction L</th>
                  <th>Correction R</th>
                  <th className={styles.colAction}>{t("mics.update")}</th>
                </tr>
              </thead>
              <tbody>
                {currentMicros.map((mic, index) => (
                  <tr key={index}>
                    <td className={styles.serial}>{mic.serial}</td>
                    <td>
                      <span
                        className={styles.typeBadge}
                        style={{
                          backgroundColor: MICRO_COLORS[mic.mictype],
                          borderColor: MICRO_TEXT_COLORS[mic.mictype],
                          color: MICRO_TEXT_COLORS[mic.mictype],
                        }}
                      >
                        {mic.mictype}
                      </span>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={styles.correctionInput}
                        value={mic.correction_L}
                        onChange={(e) =>
                          handleInputChange(
                            mic.serial,
                            mic.mictype,
                            "correction_L",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className={styles.correctionInput}
                        value={mic.correction_R}
                        onChange={(e) =>
                          handleInputChange(
                            mic.serial,
                            mic.mictype,
                            "correction_R",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className={styles.colAction}>
                      <PermissionGate actionKey="ManageMics.updateMics">
                        <button
                          type="button"
                          className={styles.updateButton}
                          onClick={() => handleUpdate(mic.serial, mic.mictype)}
                        >
                          {t("mics.update")}
                        </button>
                      </PermissionGate>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* //PAGINATION */}
          <div className={styles.containerPagination}>
            <button
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              {t("mics.first_page")}
            </button>
            <button
              onClick={() => {
                if (currentPage > 1) setCurrentPage(currentPage - 1);
              }}
              disabled={currentPage === 1}
            >
              {t("mics.previous")}
            </button>
            <button
              onClick={() => {
                if (currentPage < pageNumbers.length)
                  setCurrentPage(currentPage + 1);
              }}
              disabled={currentPage === pageNumbers.length}
            >
              {t("mics.next")}
            </button>

            <button
              onClick={() => setCurrentPage(pageNumbers.length)}
              disabled={currentPage === pageNumbers.length}
            >
              {t("mics.last_page")}
            </button>
          </div>
          <div className={styles.numberPage}>
            {t("mics.page_of", { current: currentPage, total: pageNumbers.length })}
          </div>
        </div>

        <div className={styles.importToggleBar}>
          <button
            type="button"
            className={styles.importToggleBtn}
            onClick={() => setShowImport((v) => !v)}
          >
            {showImport ? t("mics.toggle_import_json_hide") : t("mics.toggle_import_json_show")}
          </button>
        </div>

        <Modal isShowing={isShowing} hide={customToggle}>
          {activeForm === "addNewMics" && (
            <div className={styles.containerModal}>
              <div className={styles.inputWrapper}>
                <InputForms
                  onChange={(e) => setSerial(e.target.value)}
                  placeholder={t("mics.serial_number")}
                />
              </div>
              <select
                value={micType}
                className={styles.selectMicro}
                onChange={(e) => setMicType(e.target.value)}
              >
                {MICRO_TYPES.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
              <div className={styles.inputWrapper}>
                <InputForms
                  onChange={(e) => setCorrectionL(e.target.value)}
                  placeholder="Correction_L"
                />
              </div>

              <div className={styles.inputWrapper}>
                <InputForms
                  onChange={(e) => setCorrectionR(e.target.value)}
                  placeholder="Correction_R"
                />
              </div>

              <button
                type="button"
                className={styles.modalSaveBtn}
                onClick={addNewMics}
              >
                {t("common.save")}
              </button>
            </div>
          )}
          {activeForm === "warningChangeValueMics" && (
            <div className={styles.containerModal}>
              <BsFillExclamationTriangleFill
                className={styles.iconWarning}
              />
              <h2>{t("common.confirm_update")}</h2>
              <div className={styles.confirmList}>
                <div className={styles.confirmRow}>
                  <span className={styles.confirmLabel}>Serial</span>
                  <span className={styles.confirmValue}>{currentUpdate?.serial}</span>
                </div>
                <div className={styles.confirmRow}>
                  <span className={styles.confirmLabel}>MicroType</span>
                  <span className={styles.confirmValue}>{currentUpdate?.mictype}</span>
                </div>
                <div className={styles.confirmRow}>
                  <span className={styles.confirmLabel}>Correction_L</span>
                  <span className={styles.confirmValue}>{currentUpdate?.correction_L}</span>
                </div>
                <div className={styles.confirmRow}>
                  <span className={styles.confirmLabel}>Correction_R</span>
                  <span className={styles.confirmValue}>{currentUpdate?.correction_R}</span>
                </div>
              </div>
              <button
                type="button"
                className={styles.modalSaveBtn}
                onClick={confirmUpdate}
              >
                {t("common.confirm")}
              </button>
            </div>
          )}
        </Modal>
      </div>

      {showImport && (
        <div className={styles.footerSection}>
          <UploadDataMics maj={maj} setMaj={setMaj} />
          <TutorialUploadDataMics />
        </div>
      )}
    </>
  );
};

export default ManageMics;
